import React, { useState } from 'react';
import { getUnlockedEvents, TYPE_META } from '../Score/storyline';
import './Gallery.css';
import { trackEvent, EVENT_CATEGORIES, EVENT_ACTIONS } from '../../utils/analytics';

const Gallery = ({ isOpen, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const highScore = parseInt(localStorage.getItem('flappyTrumpHighScore')) || 0;

  // Story events unlocked so far, in storyline order
  const unlockedEvents = getUnlockedEvents(highScore);

  const handlePrevious = () => {
    setCurrentIndex(current =>
      current === 0 ? unlockedEvents.length - 1 : current - 1
    );
    trackEvent(EVENT_CATEGORIES.GALLERY, EVENT_ACTIONS.NAVIGATE, 'previous_event');
  };

  const handleNext = () => {
    setCurrentIndex(current =>
      current === unlockedEvents.length - 1 ? 0 : current + 1
    );
    trackEvent(EVENT_CATEGORIES.GALLERY, EVENT_ACTIONS.NAVIGATE, 'next_event');
  };

  if (!isOpen || unlockedEvents.length === 0) return null;

  const currentEvent = unlockedEvents[currentIndex];
  const meta = TYPE_META[currentEvent.type] || TYPE_META.tariff;

  return (
    <div className="Gallery-overlay" onClick={onClose}>
      <div className="Gallery-content" onClick={e => e.stopPropagation()}>
        <button
          className="Gallery-close"
          onClick={() => {
            onClose();
            trackEvent(EVENT_CATEGORIES.GALLERY, EVENT_ACTIONS.CLICK, 'close_button');
          }}
        >
          ×
        </button>

        <div className="Gallery-navigation">
          <button
            className="Gallery-nav-button"
            onClick={handlePrevious}
          >
            ←
          </button>
          <div className="Gallery-image-container">
            {currentEvent.img ? (
              <img src={currentEvent.img} alt={currentEvent.action} />
            ) : (
              <div className="Gallery-emoji">{currentEvent.emoji}</div>
            )}
            <div className="Gallery-info">
              <span className={`Gallery-badge Gallery-badge--${meta.className}`}>
                {meta.kicker}
              </span>
              <h3>{currentEvent.action}</h3>
              <p>{currentEvent.toast}</p>
              <span className="Gallery-day">Day {currentEvent.score}</span>
              <span className="Gallery-counter">
                {currentIndex + 1} / {unlockedEvents.length}
              </span>
            </div>
          </div>
          <button
            className="Gallery-nav-button"
            onClick={handleNext}
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
